// extracted by mini-css-extract-plugin
module.exports = {"button":"GenericButton_button___S0ql","small":"GenericButton_small__2bY0e","outlined":"GenericButton_outlined__1ayEb"};